
import { useParams, Link, useHistory } from "react-router-dom";

const DeleteResume = () => {
	const { id } = useParams();
	let history = useHistory();
	
	const handleDelete = () => {
		
		fetch(process.env.REACT_APP_API_URL + 'resume?id=' +  id , {
			method: 'DELETE',
			headers: { "Content-Type": "application/json" }
		})
		.then(res => {
			console.log('Application Deleted.');
			console.log(res);
			history.push('/quilly');
		})
		.catch(error => {
			console.log(error.message);
		})
	}
	
	//handleDelete();
	
	return (
		<div>
			<p className="error">ARE YOU SURE!?</p>
			<Link to={`#`} onClick={()=>{handleDelete()}}>Burn it all!</Link> | <Link to={`/quilly`}>NO!</Link>
		</div>
	);
}
export default DeleteResume;